import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';

@Component({
    selector: 'kiene-heimtier-kunde-dialog',
    templateUrl: './heimtier-kunden-excel-import-preview-dialog.component.html',
    styleUrls: ['./heimtier-kunden-excel-import-preview-dialog.component.scss'],
})
export class HeimtierKundenExcelImportPreviewDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<HeimtierKundenExcelImportPreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public kunde: Client,
    ) {}
}
